import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';

export async function hasCameraAvailable(): Promise<{ hasCamera: boolean, numberOfCameras?: number}> {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    return { hasCamera: false };
  }

  try {
    // try to get video device
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    // Stop any existing stream so we can request media with different constraints based on user input
    stream.getTracks().forEach((track) => track.stop());

    // video device found and permission are granted
    const inputDevices = await navigator.mediaDevices.enumerateDevices();
    // return count of videoDevices
    return { hasCamera: true, numberOfCameras: inputDevices.filter(d => d.kind === 'videoinput').length };
  } catch (e) {
    console.warn('error while getting video device info', e);
  }
  return { hasCamera: false };
}

export function isRatio(width: number, height: number, ratios: { w: number, h: number }[]): boolean {
  for (const ratio of ratios) {
    const calculateHeight = (width / ratio.w) * ratio.h;
    if (Math.round(calculateHeight) === height) {
      return true;
    }
  }
  return false;
}


export async function share(sharingData: ShareData, copyMessage: string): Promise<void> {
  // If we are in a native app we can use the capacitor share function
  if (Capacitor.isNativePlatform() && await Share.canShare()) {
    await Share.share({
      title: sharingData.title,
      text: sharingData.text,
      url: sharingData.url,
      dialogTitle: sharingData.title,
    });
  }
  // Check if we can share via the window.navigator
  else if (navigator && navigator.canShare && navigator.canShare(sharingData)) {
    await navigator.share(sharingData);
  }
  // Check if we can at least copy the url to the clipboard
  else if (navigator && navigator.clipboard) {
    await navigator.clipboard.writeText(window.location.href);
    alert(copyMessage);
  }
  // As a fallback we directly show the url in an url
  else {
    console.error('Could not determine a way to share the url');
    alert(sharingData.url);
  }
}

export function isMobile(): boolean {
  return Capacitor.isNativePlatform() || isMobileWebBrowser()
}

export function isMobileWebBrowser(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isFirefox(): boolean {
  return /Firefox|FxiOS/i.test(navigator.userAgent);
}
